import React from "react";
import PropTypes from "prop-types";
import styles from "./style.css";
import Arrow from  "./images/arrow.svg";
import ArrowOrange from  "./images/arrow-orange.svg";

const SlideImage = ({
    type,
    onClick = () => {},
    arrowColor
}) => {
    const getImageSrc = () => {
        if (arrowColor === "orange") {
            return ArrowOrange;
        } else {
            return Arrow;
        }
    };

    return (
        <button styleName={`${type} styles.navBtn`} className={`${type}`} onClick={onClick}>
            <img src={getImageSrc()} />
        </button>
    );
};

SlideImage.propTypes = {
    type: PropTypes.string,
    onClick: PropTypes.func,
    arrowColor: PropTypes.string
};

export default SlideImage;
